(() => {
  const TRADE_INS_QUERY_NAME = 'query-tradeinsByEmail';

  const fetchTradeIns = ({ partnerUuid, token }) => {
    const {
      GET_REFRESHED_ORDER_AND_TRADEIN_LOOKUP_TOKEN_QUERY,
    } = ORDER_TRADE_IN_RESULTS_LOADER;
    const query = `
      query tradeinsByEmail(
        $partnerUuid: String!
        $token: String!
      ) {
        tradeinsByEmail(partnerUuid: $partnerUuid, token: $token) {
          uuid
          uuidPrefix
          tradeinType
          initiatedAt
          state
          tradeinItems {
            catalogItemTitle
            itemImageUrl
          }
        }
        ${GET_REFRESHED_ORDER_AND_TRADEIN_LOOKUP_TOKEN_QUERY}
      }
    `;

    return fetchWithAppName(
      `${global.url}${TRADE_INS_QUERY_NAME}`,
      {
        body: JSON.stringify({
          query,
          variables: {
            partnerUuid,
            token,
          },
        }),
      }
    );
  };

  class TradeInLookupResultsList extends HTMLElement {
    async loadResults() {
      const { loadResults } = ORDER_TRADE_IN_RESULTS_LOADER;

      const tradeIns = Shopify.designMode ?
        // Display the empty results version of the page in the Shopify theme editor
        [] :
        (await loadResults(TRADE_INS_QUERY_NAME, fetchTradeIns)).tradeinsByEmail;

      this.replaceChildren();

      if (tradeIns?.length > 0) {
        this._renderTradeIns(tradeIns);
      } else if (tradeIns?.length === 0) {
        this._renderNoTradeIns();
      }
    }

    _renderTradeIns(tradeIns) {
      const { tradeInLookupResult } = TRADE_IN_LOOKUP_RESULT;
      tradeIns.forEach((tradeIn) => {
        this.appendChild(tradeInLookupResult(tradeIn));
      });
    }

    _renderNoTradeIns() {
      const { orderTradeInResultsEmptyState } = ORDER_TRADE_IN_RESULTS_EMPTY_STATE;
      this.appendChild(orderTradeInResultsEmptyState());
    }
  }

  if (!customElements.get('trade-in-lookup-results-list')) {
    customElements.define('trade-in-lookup-results-list', TradeInLookupResultsList);
  }
})();
